import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=f29e6d7c&scoped=true"
import script from "./mfa.vue?vue&type=script&lang=js"
export * from "./mfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29e6d7c",
  null
  
)

export default component.exports